// import React, { useState } from 'react'
// import './ProgramDashboard.css'
// import axios from 'axios'
// import { useSelector } from 'react-redux'
// function AddProgram() {
//   const orgId = useSelector(state => state.appStore?.user?.org_id)
//   const [programId, setProgramId] = useState('')
//   const [programName, setProgramName] = useState('')
//   const [programEmail, setProgramEmail] = useState('')
//   const [programPassword, setProgramPassword] = useState('')
//   const [loading, setLoading] = useState(false)
//   const [message, setMessage] = useState('')

  
//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     setMessage('')

//     if (!programId || !programName || !programEmail || !programPassword) {
//       setMessage('⚠️ Please fill all fields.')
//       return
//     }

//     setLoading(true)
//     try {
//       const payload = {
//         program_id: programId,
//         org_id: orgId,
//         prog_name: programName,
//         prog_email: programEmail,
//         prog_pass: programPassword
//       }

//       const response = await axios.post('/auth/add', payload)
//       if (response.data.success) {
//         setMessage('✅ Program added successfully!')
//         setProgramId('')
//         setProgramName('')
//         setProgramEmail('')
//         setProgramPassword('')
//       } else {
//         setMessage('❌ Failed to add program.')
//       }
//     } catch (error) {
//       console.error(error)
//       setMessage('❌ Error adding program. Please try again.')
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <div className='add-program-container'>
//       <h2 className='add-program-title'>Add New Program</h2>

//       <form className='add-program-form' onSubmit={handleSubmit}>
//         <div className='form-group'>
//           <label>Program ID</label>
//           <input
//             type='text'
//             value={programId}
//             onChange={(e) => setProgramId(e.target.value)}
//             placeholder='Enter unique program ID'
//           />
//         </div>

//         <div className='form-group'>
//           <label>Program Name</label>
//           <input
//             type='text'
//             value={programName}
//             onChange={(e) => setProgramName(e.target.value)}
//             placeholder='Enter program name'
//           />
//         </div>

//         <div className='form-group'>
//           <label>Program Email</label>
//           <input
//             type='email'
//             value={programEmail}
//             onChange={(e) => setProgramEmail(e.target.value)}
//             placeholder='Enter program email'
//           />
//         </div>

//         <div className='form-group'>
//           <label>Program Password</label>
//           <input
//             type='password'
//             value={programPassword}
//             onChange={(e) => setProgramPassword(e.target.value)}
//             placeholder='Enter program password'
//           />
//         </div>

//         <button className='submit-btn' type='submit' disabled={loading}>
//           {loading ? 'Adding...' : 'Add Program'}
//         </button>

//         {message && <p className='message'>{message}</p>}
//       </form>
//     </div>
//   )
// }

// export default AddProgram

import React, { useState, useEffect } from 'react'
import './ProgramDashboard.css'
import axios from 'axios'
import { useSelector } from 'react-redux'

function AddProgram() {
  const orgId = useSelector(state => state.appStore?.user?.org_id)
  const [programId, setProgramId] = useState('')
  const [programName, setProgramName] = useState('')
  const [programEmail, setProgramEmail] = useState('')
  const [programPassword, setProgramPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  // ✅ Generate unique program ID (string-based)
  const generateProgramId = () => {
    const prefix = 'PRG' // You can change prefix if needed
    const timestamp = Date.now().toString().slice(-6) // last 6 digits of timestamp
    return `${prefix}${timestamp}` // e.g. PRG458392
  }

  // ✅ Generate program ID on component load
  useEffect(() => {
    setProgramId(generateProgramId())
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    setMessage('')

    if (!programName || !programEmail || !programPassword) {
      setMessage('⚠️ Please fill all required fields.')
      return
    }

    setLoading(true)
    try {
      const payload = {
        program_id: programId,
        org_id: orgId,
        prog_name: programName,
        prog_email: programEmail,
        prog_pass: programPassword
      }

      const response = await axios.post('/auth/add', payload)
      if (response.data.success) {
        setMessage('✅ Program added successfully!')
        setProgramName('')
        setProgramEmail('')
        setProgramPassword('')
        setProgramId(generateProgramId()) // new ID after success
      } else {
        setMessage('❌ Failed to add program.')
      }
    } catch (error) {
      console.error(error)
      setMessage('❌ Error adding program. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='add-program-container'>
      <h2 className='add-program-title'>Add New Program</h2>

      <form className='add-program-form' onSubmit={handleSubmit}>
        <div className='form-group'>
          <label>Program ID</label>
          <input
            type='text'
            value={programId}
            readOnly
            className='readonly-input'
          />
        </div>

        <div className='form-group'>
          <label>Program Name</label>
          <input
            type='text'
            value={programName}
            onChange={e => setProgramName(e.target.value)}
            placeholder='Enter program name'
          />
        </div>

        <div className='form-group'>
          <label>Program Email</label>
          <input
            type='email'
            value={programEmail}
            onChange={e => setProgramEmail(e.target.value)}
            placeholder='Enter program email'
          />
        </div>

        <div className='form-group'>
          <label>Program Password</label>
          <input
            type='password'
            value={programPassword}
            onChange={e => setProgramPassword(e.target.value)}
            placeholder='Enter program password'
          />
        </div>

        <button className='submit-btn' type='submit' disabled={loading}>
          {loading ? 'Adding...' : 'Add Program'}
        </button>

        {message && <p className='message'>{message}</p>}
      </form>
    </div>
  )
}

export default AddProgram
